import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import "../Styles/Navbar.css"; 


const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);


  

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <a href="/">
        <img className="logo" src="/images/mainlogo.png" alt="logo" />
        </a>
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/products">Products</Link></li>
          <li><Link to="/pricing">Pricing</Link></li>
          <li><Link to="/policies">Policies</Link></li>
          <li><Link to="/Contact">Contact</Link></li>
        </ul>
        <div className="hamburger" onClick={toggleMenu}>
          <div className={`line ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`line ${isMenuOpen ? 'open' : ''}`}></div>
          <div className={`line ${isMenuOpen ? 'open' : ''}`}></div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
